import { RingFinishEnum } from '../enums/RingFinishEnum';
import { RingStyleEnum } from '../enums/RingStyleEnum';

export const RING_FINISHES = Object.values(RingFinishEnum);

export const RING_STYLES = Object.values(RingStyleEnum);
